import React, { useEffect, useState } from 'react';
import SocialMedia from './parts/SocialMedia';
import Support from './parts/Support';

import styles from './SocialServices.module.css';

const texts = ['Easy access to payment reports', 'Bulk salary payments', 'Unbeatable speed'];

const SocialServices = () => {
  const [text, setText] = useState<string>(texts[0]);

  useEffect(() => {
    const interval = setInterval(() => setText(texts[Math.floor(Math.random() * texts.length)]), 3000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className={styles.services}>
      <div>
        <Support />
        <SocialMedia />
      </div>
      <div className={styles.textContainer}>
        <span className={styles.text}>{text}</span>
      </div>
    </div>
  );
};

export default SocialServices;
